<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="modalCtrl.dismiss()">
        <ion-icon class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="inner-container">
    <app-public-profile-item class="listing-item hit-border" [showControls]="false" [regionalLenderView]="false"
      [pairedAgentData]="pairedAgentData">
    </app-public-profile-item>
  </div>

  <div class="loading-container ion-text-center" *ngIf="isLoading">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <ion-row *ngIf="!isLoading">
    <ion-col sizeXs="12" sizeSm="5" sizeMd="5" sizeLg="5" sizeXl="5">
      <ion-item lines="none" class="ion-item-custom">
        <ion-label>
          <span class="lbl">Primary Email</span>
          <span class="val" *ngIf="!contactData?.email">N/A</span>
          <span class="val" *ngIf="contactData?.email">{{contactData?.email}}</span>
        </ion-label>
        <ion-button [disabled]="!contactData?.email" class="copy-button" slot="end" fill="clear" (click)="copyVal(contactData.email)">
          <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
        </ion-button>
      </ion-item>     
    </ion-col>
    <ion-col class="spacer-col"></ion-col>
    <ion-col sizeXs="12" sizeSm="5" sizeMd="5" sizeLg="5" sizeXl="5">
      <ion-item lines="none" class="ion-item-custom">
        <ion-label>
          <span class="lbl">Mobile Phone</span>
          <span class="val" *ngIf="!contactData?.phone">N/A</span>
          <span class="val" *ngIf="contactData?.phone">{{common.formatPhone(contactData?.phone)}}</span>
        </ion-label>
        <ion-button [disabled]="!contactData?.phone" class="copy-button" slot="end" fill="clear" (click)="copyVal(contactData.phone)">
          <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-col>
  </ion-row>

  <!-- <ion-row>
    <ion-col sizeXs="12" sizeSm="5" sizeMd="5" sizeLg="5" sizeXl="5">
      <div class="detail-container">
        <span class="lbl">Primary Email</span>
        <span class="val">{{contactData?.email}}</span>
        <div class="copy-button-container">
          <ion-button fill="clear" (click)="copyVal(contactData.email)">
            <ion-icon name="copy-outline" slot="start"></ion-icon>
            <ion-label>Copy</ion-label>
          </ion-button>
        </div>
      </div>
    </ion-col>
    <ion-col class="spacer-col"></ion-col>
    <ion-col sizeXs="12" sizeSm="5" sizeMd="5" sizeLg="5" sizeXl="5">
      <div class="detail-container">
        <span class="lbl">Mobile Phone</span>
        <span class="val">{{common.formatPhone(contactData?.phone)}}</span>
        <div class="copy-button-container">
          <ion-button fill="clear" (click)="copyVal(contactData.phone)">
            <ion-icon name="copy-outline" slot="start"></ion-icon>
            <ion-label>Copy</ion-label>
          </ion-button>
        </div>
      </div>
    </ion-col>
  </ion-row> -->

</ion-content>